<dx-box width="100%" height="100%" direction="col">
    <dxi-item [ratio]="1">
        <div *dxTemplate>
            <app-manage-invoice-grid
                workOrderStatus="open"
                [invoiceIds]="invoiceIds"
                [communityId]="communityId"
                [invoiceGridSource]="openInvoices"
                (onRowSelectionChange)="onInvoiceSelectionChange($event)"
            ></app-manage-invoice-grid>
        </div>
    </dxi-item>
</dx-box>
